module.exports = __webpack_public_path__ + "media/assets/images/flags/pa-8826c90d5c18db0a917f39071c50effa.svg";